import { LanguageConfig, TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY } from "config/CustomEnums";
import { validateContentPage } from "../campaignStreamline/CreateCampaignValidate";

const validateEventTimeSlot = ({
  getValues,
  languages,
}) => {
  let errorList = [];
  const [
    ticketCampaignTimeSlots,
    showCustomerProfileFields,
    showCustomerAdditionalFields,
    additionalQuestion,
  ] = getValues([
    'ticketCampaignTimeSlots',
    'showCustomerProfileFields',
    'showCustomerAdditionalFields',
    'additionalQuestion',
  ]);

  let couponSetPkIndexMap = {};
  if (ticketCampaignTimeSlots?.length > 0) {
    ticketCampaignTimeSlots.forEach((item, index) => {
      const { couponSet, translations } = item;
      const enTimeSlot = translations?.[LanguageConfig.english]?.timeSlot;
      if (!couponSet?.pk) {
        errorList.push({
          sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
          name: `ticketCampaignTimeSlots.${index}.couponSet`,
          message: 'Please select a ticket set.',
        });
      } else {
        couponSetPkIndexMap[couponSet.pk] = [
          ...(couponSetPkIndexMap?.[couponSet.pk] || []),
          index,
        ];
      }
      if (!enTimeSlot) {
        errorList.push({
          sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
          name: `ticketCampaignTimeSlots.${index}.translations.${LanguageConfig.english}.timeSlot`,
          message: 'Please input time slot.',
        });
      }
    });
  } else {
    errorList.push({
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
      name: `ticketCampaignTimeSlots.0.couponSet`,
      message: 'Please select a ticket set.',
    });
  }

  const couponsSetPks = Object.keys(couponSetPkIndexMap) || [];
  let duplicateCouponSetIndex = [];

  couponsSetPks?.length > 0 &&
    couponsSetPks.forEach((couponSetPk) => {
      if (couponSetPkIndexMap?.[couponSetPk]?.length <= 1) {
        return;
      }
      duplicateCouponSetIndex = duplicateCouponSetIndex.concat(
        couponSetPkIndexMap?.[couponSetPk],
      );
    });
  duplicateCouponSetIndex?.length > 0 &&
    duplicateCouponSetIndex.forEach((couponSetIndex) => {
      errorList.push({
        sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
        name: `ticketCampaignTimeSlots.${couponSetIndex}.couponSet`,
        message: 'Duplicated ticket set.',
      });
    });

  const questionFieldNames = [];
  showCustomerProfileFields?.length > 0 &&
    showCustomerProfileFields.forEach(item => {
      questionFieldNames.push(item.fieldName);
    });

  showCustomerAdditionalFields?.length > 0 &&
    showCustomerAdditionalFields.forEach(item => {
      questionFieldNames.push(item.fieldName)
    })

  additionalQuestion?.length > 0 &&
    additionalQuestion.forEach((item, index) => {
      const fieldName = item?.translations?.[LanguageConfig.english]?.fieldName;
      if (questionFieldNames.includes(fieldName)) {
        errorList.push({
          sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionKey,
          name: `ticketCampaignAdditionalQuestion.${index}.fieldName`,
          message: 'Duplicated field name, please change to another',
        })
      }
      questionFieldNames.push(fieldName);
    });

  return errorList
}

export function validateEvent({
  dispatch,
  getValues,
  setError,
  clearErrors,
  languages = [LanguageConfig.english],
}) {
  clearErrors();

  let errorList = [];
  const errorSectionList = [];

  const contentPageError = validateContentPage({
    getValues,
    languages,
    hideInFrontend: false,
  })
  const propertiesPageError = validateEventTimeSlot({
    getValues,
    languages,
  });
  errorList = [
    ...contentPageError,
    ...propertiesPageError,
  ];

  errorList.forEach(item => {
    if (item.sectionKey) {
      errorSectionList.push(item.sectionKey);
    }
  })

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });

  if (errorList?.some(error => error?.name?.startsWith("ticketCampaignTimeSlots."))) {
    errorList.push({
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
      name: `ticketCampaignTimeSlots`,
      message: 'Error',
    })
  }
  if (errorList?.some(error => error?.name?.startsWith("ticketCampaignAdditionalQuestion."))) {
    errorList.push({
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionKey,
      name: `ticketCampaignAdditionalQuestion`,
      message: 'Error',
    })
  }

  dispatch({
    type: 'createCampaign/updateState',
    payload: {
      errorFields: errorList.map(item => item.name),
      errorSectionList,
    }
  })

  return !errorList.length;

}